/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const organizationSchema = z.object({
      "id": z.string(),
  "name": z.string()
      })